import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Alert,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { isEco } from 'helpers/RequestHelper';
import { notifyMessages } from 'helpers/NotifyHelper';
import { isMatchURL } from 'helpers/StringHelper';
import { updateDeviceModel, fetchRequest } from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class FccidForm extends Component {
  state = { value: '' };

  handleChange = event => {
    const value = _.trim(event.target.value);
    this.setState({ value });
  };

  handleSubmit = event => {
    event.preventDefault();

    const {
      updateDeviceModel,
      request,
      startPreloader,
      finishPreloader,
      fetchRequest,
      showNotice
    } = this.props;

    startPreloader();
    updateDeviceModel(request.model.id, { fccid: this.state.value })
      .then(() => {
        return fetchRequest(request.id);
      })
      .then(() => {
        finishPreloader();
        showNotice(notifyMessages.fccidAssigned);
      });
  };

  allowSubmit = () => String(this.state.value).length > 0;

  render() {
    const { request } = this.props;
    const fccId = String(request.fccId);
    if (fccId.length || isEco(request.requesttypeid)) return null;

    // shows only on enter test results tab
    const url = 'lab/results';
    if (!isMatchURL(url)) return null;

    return (
      <div>
        <Alert bsStyle="danger">
          <form>
            <FormGroup controlId="fccid">
              <ControlLabel>
                You must enter assigned FCCID for the request to certify the
                device:
              </ControlLabel>
              <FormControl
                type="text"
                value={this.state.value}
                placeholder="Enter FCCID value"
                onChange={this.handleChange}
              />
            </FormGroup>
          </form>
          <p>
            <Button
              bsStyle="danger"
              bsSize="small"
              onClick={this.handleSubmit}
              disabled={!this.allowSubmit()}
            >
              Assign FCCID
            </Button>
          </p>
        </Alert>
      </div>
    );
  }
}

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  {
    updateDeviceModel,
    startPreloader,
    finishPreloader,
    fetchRequest,
    showNotice
  }
)(FccidForm);



// WEBPACK FOOTER //
// ./src/containers/testResult/FccidForm.js